import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import ErrorBoundary from './components/ErrorBoundary';
import { FlipbasePlayer } from './components/FlipbasePlayer';
import { FlipbaseRecorder } from './components/FlipbaseRecorder';
import { FlipbaseConfig } from './types/flipbase';

const AppContent: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [config, setConfig] = useState<FlipbaseConfig>({
    apiKey: '',
    apiSecret: '',
    playerId: '',
    videoId: '',
    recorderId: '',
    useSignature: false
  });

  React.useEffect(() => {
    // Simulate checking for saved configuration or other initialization
    const initializeApp = async () => {
      try {
        // Parse query parameters from the hash
      const urlParams = new URLSearchParams(window.location.search);
      const playerIdFromUrl = urlParams.get('playerId');
      const recorderIdFromUrl = urlParams.get('recorderId');
        // Here you could load saved config from localStorage if needed
        const savedConfig = localStorage.getItem('flipbaseConfig');
        let parsedConfig = savedConfig && savedConfig !== 'undefined' ? JSON.parse(savedConfig) : {};
        
        // Override with query params if they exist
        if (playerIdFromUrl) {
          parsedConfig.playerId = playerIdFromUrl;
        }
        if (recorderIdFromUrl) {
          parsedConfig.recorderId = recorderIdFromUrl;
        }
        
        if (playerIdFromUrl || recorderIdFromUrl || savedConfig) {
          setConfig(prev => ({
            ...prev,
            ...parsedConfig
          }));
        }
      } catch (error) {
        console.error('Error initializing app:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initializeApp();
  }, []);

  const handleConfigChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setConfig(prev => {
      const newConfig = {
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      };
      
      // Save to localStorage
      try {
        localStorage.setItem('flipbaseConfig', JSON.stringify(newConfig));
      } catch (error) {
        console.error('Error saving config:', error);
      }
      
      return newConfig;
    });
  };

  if (isLoading) {
    return (
      <div className="App" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="header">
        <h1>Flipbase Tester</h1>
        <p className="environment">
          API Endpoint: {process.env.REACT_APP_API_ENDPOINT}
        </p>
      </div>

      <div className="container">
        {/* <div className="tabs">
          <Link to="/player">
            <button className={location.pathname === '/player' ? 'active' : ''}>
              Player
            </button>
          </Link>
          <Link to="/recorder">
            <button className={location.pathname === '/recorder' ? 'active' : ''}>
              Recorder
            </button>
          </Link>
        </div> */}

        <div className="config-panel">
          <div className="input-group">
            <label>
              API Key:
              <input
                type="text"
                name="apiKey"
                value={config.apiKey}
                onChange={handleConfigChange}
                placeholder="Your Flipbase API Key"
                data-testid="input-api-key"
              />
            </label>
          </div>

          <div className="input-group">
            <label>
              API Secret:
              <input
                type="password"
                name="apiSecret"
                value={config.apiSecret}
                onChange={handleConfigChange}
                placeholder="Your Flipbase API Secret"
                data-testid="input-api-secret"
              />
            </label>
          </div>

            <>
              <div className="input-group">
                <label>
                  Player ID:
                  <input
                    type="text"
                    name="playerId"
                    value={config.playerId}
                    onChange={handleConfigChange}
                    placeholder="Player ID"
                    data-testid="input-player-id"
                  />
                </label>
              </div>

              <div className="input-group">
                <label>
                  Video ID:
                  <input
                    type="text"
                    name="videoId"
                    value={config.videoId}
                    onChange={handleConfigChange}
                    placeholder="Video ID"
                    data-testid="input-video-id"
                  />
                </label>
              </div>
            </>

            <div className="input-group">
              <label>
                Recorder ID:
                <input
                  type="text"
                  name="recorderId"
                  value={config.recorderId}
                  onChange={handleConfigChange}
                  placeholder="Recorder ID"
                  data-testid="input-recorder-id"
                />
              </label>
            </div>

          <div className="input-group checkbox">
            <label>
              <input
                type="checkbox"
                name="useSignature"
                checked={config.useSignature}
                onChange={handleConfigChange}
              />
              Use Signature (Secure Mode)
            </label>
          </div>
        </div>

          <h2>
            Player v2
          </h2>
        <FlipbasePlayer config={config}/>
        <h2>
          Recorder V2
        </h2>
        <FlipbaseRecorder 
          config={config}
          onVideoRecorded={(videoId) => {
            setConfig(prev => {
              const newConfig = {
                ...prev,
                videoId
              };
              try {
                localStorage.setItem('flipbaseConfig', JSON.stringify(newConfig));
              } catch (error) {
                console.error('Error saving config:', error);
              }
              return newConfig;
            });
          }}
        />
      </div>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <ErrorBoundary>
        <AppContent />
      </ErrorBoundary>
    </Router>
  );
};

export default App;
